import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { globalWidgets } from 'ducks';
import { duckify, singleDuck } from 'utils/duckify';
import { GlobalWidgetType } from 'propTypes';
import { formatDateTime } from 'utils';
import SAFroala from 'components/SAFroala/SAFroala';
import Placeholder from 'components/Placeholder';
import FroalaEditor from 'froala-editor';

const ManageSetupHome = (props) => {
  const {
    allDucksReady,
    setupHomeWidget1,
    setupHomeWidget2,
    saveWidget
  } = props;

  const [widget1, setWidget1] = useState();
  const [widget2, setWidget2] = useState();

  useEffect(() => {
    setWidget1(setupHomeWidget1.body);
    setWidget2(setupHomeWidget2.body);
  }, [allDucksReady]);

  return (
    <div className='setup-home'>
      <h2>Manage Setup Home</h2>
      <div className='widget-container'>
        <div className='widget'>
          <Placeholder.SAFroala ready={allDucksReady} width={660}>
            <SAFroala
              value={widget1}
              onModelChange={value => setWidget1(value)}
              showFormatting
              froalaOptions={{
                enter: FroalaEditor.ENTER_BR
              }}
            />
          </Placeholder.SAFroala>
          <br />
          <p>
            Last Updated:&nbsp;
            {setupHomeWidget1.updated_at ? formatDateTime(setupHomeWidget1.updated_at) : 'Never'}
          </p>
          <button
            type='submit'
            className='btn btn-primary'
            onClick={() => saveWidget(Object.assign(setupHomeWidget1, { body: widget1 }))}
          >
            Save
          </button>
        </div>
        <div className='widget'>
          <Placeholder.SAFroala ready={allDucksReady} width={660}>
            <SAFroala
              value={widget2}
              onModelChange={value => setWidget2(value)}
              showFormatting
              froalaOptions={{
                enter: FroalaEditor.ENTER_BR
              }}
            />
          </Placeholder.SAFroala>
          <br />
          <p>
            Last Updated:&nbsp;
            {setupHomeWidget2.updated_at ? formatDateTime(setupHomeWidget2.updated_at) : 'Never'}
          </p>
          <button
            type='submit'
            className='btn btn-primary'
            onClick={() => saveWidget(Object.assign(setupHomeWidget2, { body: widget2 }))}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

ManageSetupHome.propTypes = {
  allDucksReady: PropTypes.bool,
  setupHomeWidget1: GlobalWidgetType.isRequired,
  setupHomeWidget2: GlobalWidgetType.isRequired,
  saveWidget: PropTypes.func.isRequired
};

ManageSetupHome.defaultProps = {
  allDucksReady: false
};

const mapDucksToProps = () => ({
  setupHomeWidget1: singleDuck(globalWidgets, 'setup_home_widget1'),
  setupHomeWidget2: singleDuck(globalWidgets, 'setup_home_widget2')
});

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  saveWidget: (widget) => dispatch(globalWidgets.actions.save(widget))
});

export default duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(ManageSetupHome);
